import { Container } from "react-bootstrap";
import RegisterForm from "../components/RegisterForm";

export default function RegisterPage() {
    return (
        <>
            <Container>
                <RegisterForm />
            </Container>
        </>
    );
}
